// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1F6j2","col":"styles_col__1rqQ2","fulfillmentStatus":"styles_fulfillmentStatus__B27xf","emailCol":"styles_emailCol__1CAtk"};